import { OctTable } from "@oceantech/oceantech-ui";
import {useContext, useEffect, useMemo, useState} from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import DatePickerCustom from "../component/date-picker/DatePickerCustom";
import LabelRequired from "../component/LabelRequired";
import TextValidator from "../component/TextValidator";
import { IConfigTable } from "../models/OctResponse";
import {
  CODE_SUCCESS,
  ERROR_MESSAGE,
  INIT_SEARCH_OBJECT, SEARCH_OBJECT_MAX_SIZE,
  TYPE,
} from "../utils/Constant";
import {
  EVALUATE_STATUS,
  MESSAGE_CONFIRM_DIALOG,
  TYPE_CONFIRM_DIALOG,
} from "./constants/criteriaModal";
import "./CriteriaPage.scss";
import CriteriaModal from "./modals/CriteriaModal";
import { AppContext } from "../appContext/AppContext";
import {
  getDataReport,
  getListCriteria,
  updateStatusAssessment,
} from "./services/CriteriaServices";
import { toast } from "react-toastify";
import { ConfirmDialog } from "../component/ConfirmDialog";
import { ISearchCriteria } from "./models/CriteriaModels";
import { getPlans } from "../build-plan/services/PlanServices";
import {CriteriaColumns} from "./columns";
import {CRITERIA_REPORT_MODEL_JSON, INITIAL_TYPE, LIST_CRITERIA, PRINT_STYLES} from "./constants/commons";
import AutocompleteV2 from "../component/AutocompleteObjectV2";
import {CriteriaReportProvider} from "./context/CriteriaReportContext";
import ModalPhieuIn from "../component/ModalPhieuIn";
import TemplateSummarizeReport from "./components/TemplateSummarizeReport";

type Props = {};

const CriteriaPage = (props: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const {_83_TIEU_CHI, _CHI_SO_CHAT_LUONG, _TIEU_CHUAN_CHAT_LUONG, _XEP_CAP_CHUYEN_MON_KT, _MUC_DO_ATPT} = LIST_CRITERIA;

  const [objectSearch, setObjectSearch] = useState<ISearchCriteria>({
    ...INIT_SEARCH_OBJECT,
    pageSize: 20,
  });
  const [data, setData] = useState<any[]>([]);
  const [reload, setReload] = useState(false);
  const [criteria, setCriteria] = useState<any>(null);
  const [criteriaType, setCriteriaType] = useState<any>(null);
  const [listCriteriaType, setListCriteriaType] = useState(Object.values(LIST_CRITERIA));
  const [listPlan, setListPlan] = useState<any[]>([]);
  const [dataPrint, setDataPrint] = useState<any[]>([]);
  const [openModalPrint, setOpenModalPrint] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
  const [configTable, setConfigTable] = useState<IConfigTable>({
    totalPages: 1,
    totalElements: 5,
    numberOfElements: 5,
  });
  const [showModalCriteria, setShowModalCriteria] = useState({
    open: false,
    type: INITIAL_TYPE,
  });
  const [dataChecked, setDataChecked] = useState<any[]>([]);
  const [showModalConfirm, setShowModalConfirm] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    handleGetListCriteria().then(r => r);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, objectSearch.pageIndex, objectSearch.pageSize, objectSearch.plan]);

  const handleGetListCriteria = async () => {
    switch (criteriaType?.value) {
      case _XEP_CAP_CHUYEN_MON_KT.value:
      // {
      //   if (!objectSearch?.plan?.id) {
      //     setData([]);
      //     return;
      //   }
      //   const listData = flattenQualityIndicatorCriteria.map(item => ({
      //     ...item,
      //     planId: objectSearch?.plan?.id,
      //     planName: objectSearch?.plan?.name,
      //   }))
      //   setData(listData);
      //   break;
      // }
      case _CHI_SO_CHAT_LUONG.value:
      case _TIEU_CHUAN_CHAT_LUONG.value:
      case _MUC_DO_ATPT.value:
      case _83_TIEU_CHI.value:
      default:
        await handleGet83Criteria();
        break;
    }
  };

  const handleGet83Criteria = async () => {
    if (!objectSearch?.plan?.id) {
      setData([]);
      return;
    }

    try {
      setIsLoading(true);
      const params = {
        ...objectSearch,
        planId: objectSearch?.plan?.id,
        planName: objectSearch?.plan?.name,
        classId: criteriaType?.value,
      };
      delete params.plan;

      const { data } = await getListCriteria(params);
      if (data?.code === CODE_SUCCESS) {
        setData(data?.data?.content);
        setConfigTable({
          totalPages: data?.data?.totalPages,
          totalElements: data?.data?.totalElements,
          numberOfElements: data?.data?.numberOfElements,
        });
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenCriteriaModal = (type: string, criteria: any) => {
    setShowModalCriteria({
      open: true,
      type: {
        modalType: type,
        form: CRITERIA_REPORT_MODEL_JSON[criteriaType?.value || 0],
      },
    });
    setCriteria(criteria);
  };

  const evaluateColumns = useMemo(() => CriteriaColumns(criteriaType?.value)({
    handleOpenCriteriaModal,
  }), [criteriaType?.value]);

  const handleCloseCriteriaModal = () => {
    setShowModalCriteria({ open: false, type: INITIAL_TYPE});
    setReload(!reload);
    setCriteria(null);
  }

  const handleUpdateStatus = async () => {
    setIsLoading(true);
    const dataRequest = {
      status: EVALUATE_STATUS.EVALUATED.code,
      ids: dataChecked?.map((item: any) => item?.id),
    };
    try {
      const { data } = await updateStatusAssessment(dataRequest);

      if (data?.code === CODE_SUCCESS) {
        toast.success("Hoàn thành đánh giá thành công!");
        handleCloseConfirmDialog();
        setReload(!reload);
      }
    } catch (error) {
      console.error("error", error);
      toast.error(ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenConfirmDialog = (message: string, type: string) => {
    const isEvaluation = type === TYPE_CONFIRM_DIALOG.COMPLETE_EVALUATE
    if (!dataChecked?.length && isEvaluation) {
      return toast.warning("Vui lòng chọn tiêu chí!");
    }

    const hasEvaluatedCriteria = dataChecked.some(
      (item: any) => item?.status === EVALUATE_STATUS.EVALUATED.code
    );

    if (hasEvaluatedCriteria && isEvaluation) {
      return toast.warning("Có tiêu chí đã được hoàn thành đánh giá!");
    }

    setShowModalConfirm({
      open: true,
      message: message,
      type: type,
    });
  };

  const handleCloseConfirmDialog = () => {
    setShowModalConfirm({ open: false, message: "", type: "" });
    setDataChecked([]);
  };

  const handleConfirm = () => {
    const options: { [key: string]: () => Promise<void> } = {
      [TYPE_CONFIRM_DIALOG.COMPLETE_EVALUATE]: () => handleUpdateStatus(),
    };
    options[showModalConfirm?.type]?.();
  };

  const handleChangeFilter = (name: string, value: any) => {
    setObjectSearch({
      ...objectSearch,
      [name]: value,
    });
  };

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      handleSubmitSearch();
    }
  };

  const handleSubmitSearch = () => {
    setReload(!reload);
    setObjectSearch({
      ...objectSearch,
      pageIndex: 1,
    });
  };

  const handleCriteriaType = (value: any) => {
    setCriteriaType(value);
    handleChangeFilter("plan", null);
    setData([])
    setConfigTable({
      totalPages: 1,
      totalElements: 5,
      numberOfElements: 5,
    })
  }

  const handleOpenModalPrint = async () => {
    if (!objectSearch?.plan?.id) {
      return toast.warning("Vui lòng chọn kế hoạch!");
    }
    // const params = {
    //   ...objectSearch,
    //   planId: objectSearch?.plan?.id,
    //   planName: objectSearch?.plan?.name,
    // };
    // delete params.plan;
    // setIsLoading(true);
    // try {
    //   const { data } = await getDataReport(params);
    //   if (data?.code === CODE_SUCCESS) {
    //     setDataPrint(data?.data);
    //   }
    // } catch (error) {
    //   console.error("error", error);
    //   toast.error(ERROR_MESSAGE);
    // } finally {
    //   setIsLoading(false);
    // }

    setDataPrint([])
    setOpenModalPrint(true);
  };

  const handleCloseModalPrint = () => {
    setOpenModalPrint(false);
  };

  const contextValue = useMemo(() => ({
    isView,
    criteriaType,
    criteria,
    setCriteria,
  }), [criteria, criteriaType, isView]);

  return (
    <CriteriaReportProvider value={contextValue}>
      <div className="pe-list">
        <div className="h-100 bg-white">
          <div className="reception-list__container spaces py-0">
            <div className="px-3 pt-2 border-bottom">
              <div className="text-title">Danh sách tiêu chí</div>
            </div>

            <div className="d-flex align-items-center px-3 pt-2 gap-3">
              <Button
                className="btn-fill spaces min-w-150 h-29"
                onClick={() =>
                  handleOpenConfirmDialog(
                    MESSAGE_CONFIRM_DIALOG[TYPE_CONFIRM_DIALOG.COMPLETE_EVALUATE],
                    TYPE_CONFIRM_DIALOG.COMPLETE_EVALUATE
                  )
                }
              >
                Hoàn thành đánh giá
              </Button>
              <Button
                className="btn-fill spaces min-w-150 h-29"
                onClick={handleOpenModalPrint}
              >
                Tổng hợp đánh giá
              </Button>
              <div className="d-flex spaces align-items-center min-w-500">
                <LabelRequired
                  className="min-w-75px fw-bold"
                  label="Bộ Tiêu chí"
                />
                <AutocompleteV2
                  options={listCriteriaType}
                  value={criteriaType ?? null}
                  name="criteriaType"
                  onChange={handleCriteriaType}
                  className="spaces h-29 width-100"
                />
              </div>
            </div>
            <div className="d-flex px-3 pt-2 gap-3">
              <div className="d-flex spaces align-items-center min-w-250">
                <LabelRequired
                  className="min-w-65px fw-bold"
                  label="Kế hoạch"
                />
                <AutocompleteV2
                  className="spaces h-29 min-w-300"
                  options={[]}
                  searchFunction={getPlans}
                  searchObject={{
                    ...SEARCH_OBJECT_MAX_SIZE,
                    classId: criteriaType?.value,
                  }}
                  value={objectSearch?.plan ?? null}
                  name="plan"
                  onChange={(selectedOption) => {
                    handleChangeFilter("plan", selectedOption);
                  }}
                  disabled={!criteriaType}
                />
              </div>
              <div className="d-flex spaces align-items-center">
                <LabelRequired className="max-content-width spaces mr-5" label="Từ ngày"/>
                <DatePickerCustom
                  placeholderText="dd/mm/yyyy"
                  name="startDate"
                  value={objectSearch?.startDate ?? ""}
                  setDateValue={(date) => {
                    handleChangeFilter("startDate", date);
                  }}
                  dateFormatOutput="YYYY-MM-DD"
                />
              </div>
              <div className="d-flex spaces align-items-center">
                <LabelRequired className="max-content-width spaces mr-5" label="Đến ngày"/>
                <DatePickerCustom
                  placeholderText="dd/mm/yyyy"
                  name="endDate"
                  value={objectSearch?.endDate ?? ""}
                  setDateValue={(date) => {
                    handleChangeFilter("endDate", date);
                  }}
                  dateFormatOutput="YYYY-MM-DD"
                />
              </div>
              <div className="d-flex align-items-center flex-grow-1">
                <LabelRequired className="max-content-width spaces mr-5" label="Từ khóa"/>
                <InputGroup className="spaces h-29 px-0">
                  <TextValidator
                    className="spaces h-29 min-w-200 rounded-end-0"
                    name="keyword"
                    placeholder="Tìm kiếm theo mã, tên kế hoạch"
                    value={objectSearch?.keyword || ""}
                    onChange={(e: any) =>
                      handleChangeFilter("keyword", e.target.value)
                    }
                    onKeyDown={handleKeyPress}
                  />
                  <Button
                    className="btn-fill spaces h-29"
                    onClick={handleSubmitSearch}
                  >
                    <i className="bi bi-search"></i>
                    <span>Lọc</span>
                  </Button>
                </InputGroup>
              </div>
            </div>

            <OctTable
              id="searchCriteria"
              className={`mt-7 table-background-th width-100 spaces h-calc-vh-265`}
              data={data}
              columns={evaluateColumns}
              searchObject={objectSearch}
              setSearchObject={setObjectSearch}
              fixedColumnsCount={-1}
              noToolbar={true}
              totalPages={configTable.totalPages}
              totalElements={configTable.totalElements}
              numberOfElements={configTable.numberOfElements}
              // handleDoubleClick={handleDoubleClick}
              isShowSelection={false}
              clearToolbar={true}
              type={TYPE.MULTILINE}
              setDataChecked={(dataChecked) => setDataChecked(dataChecked)}
            />
          </div>
        </div>

        {showModalCriteria.open && (
          <CriteriaModal
            show={showModalCriteria.open}
            handleCloseDialog={handleCloseCriteriaModal}
            type={showModalCriteria.type}
          />
        )}

        <ModalPhieuIn
          show={openModalPrint}
          handleCloseDialog={handleCloseModalPrint}
          title="Tổng hợp báo cáo"
          size="xl"
          stylePrint={PRINT_STYLES}
        >
          <TemplateSummarizeReport data={dataPrint} />
        </ModalPhieuIn>

        {showModalConfirm.open && (
          <ConfirmDialog
            show={showModalConfirm.open}
            message={showModalConfirm.message}
            yes="Xác nhận"
            onYesClick={handleConfirm}
            cancel="Hủy"
            onCancelClick={handleCloseConfirmDialog}
          />
        )}
      </div>
    </CriteriaReportProvider>
  );
};

export default CriteriaPage;
